import { Component, OnInit, Inject, OnDestroy, ViewChild } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ReCaptcha2Component } from 'ngx-captcha';
import { ToastrService } from 'ngx-toastr';
import { SignupService } from 'src/app/services/signup.service';

@Component({
  selector: 'dialog-forgot-my-password-dialog',
  templateUrl: 'forgot-my-password-dialog.html',
  styleUrls: ['forgot-my-password-dialog.css'],
})
export class ForgotMyPasswordDialog implements OnDestroy, OnInit {
  shipmentData: any = {};
  userId: string = '';
  recaptchaCheckboxKey = '6LfzUlUaAAAAAKKv0UBaepUWBOJKiZ62xqtvqREh';

  @ViewChild('captchaElem', { static: false })
  captchaElem!: ReCaptcha2Component;

  forgotPasswordForm = new UntypedFormGroup({
    email: new UntypedFormControl('', [Validators.required, Validators.email]),
    forgotPassRecaptcha: new UntypedFormControl('', Validators.required),
  });

  resetCaptcha() {
    this.captchaElem.resetCaptcha();
  }

  onCaptchaExpired() {
    this.resetCaptcha();
  }
  constructor(
    private signUpService: SignupService,
    public dialogRef: MatDialogRef<ForgotMyPasswordDialog>,
    private toastr: ToastrService
  ) {}
  ngOnInit(): void {}
  close(): void {
    this.dialogRef.close();
  }
  ngOnDestroy(): void {
    this.shipmentData = {};
  }

  forgotPasswordValidation() {
    var hasError = false;
    if (this.forgotPasswordForm.controls.email.status == 'INVALID') {
      this.forgotPasswordForm.controls.email.markAsTouched();
      hasError = true;
    }
    if (
      this.forgotPasswordForm.controls.forgotPassRecaptcha.status == 'INVALID'
    ) {
      this.forgotPasswordForm.controls.forgotPassRecaptcha.markAsTouched();
      this.toastr.error('Recaptcha Error');
      hasError = true;
    }
    return hasError;
  }
  handleReset() {}

  forgotPassword() {
    const recaptcha = {
      action: 'FORGOT_PASSWORD',
      token: this.forgotPasswordForm.value.forgotPassRecaptcha,
    };
    if (this.forgotPasswordValidation() == false) {
      var userData = {
        email: this.forgotPasswordForm.value.email,
        recaptcha_token: recaptcha,
      };
      this.signUpService.forgotPassword(userData).subscribe({
        next: (data) => {
          if (data['result']['status'] == 200) {
            this.toastr.success(data['result']['message'], 'Success');
            this.forgotPasswordForm.reset();
            this.dialogRef.close();
          } else {
            this.toastr.error(data['result']['message'], 'Error');
          }
        },
        error: (err) => {},
      });
    }
  }
}
